
// @ts-ignore
export const setMap = (state, map) => {
  state.map = map;
};

// @ts-ignore
export const setAddress = (state, gps) => {
  state.gps = gps;
};

// @ts-ignore
export const setName = (state, name) => {
  state.name = name;
};
